import { Smartphone, RefreshCw, AlertCircle } from "lucide-react";
import ProductPage from "@/components/ProductPage";
import {
  useDocumentTitle,
  DEFAULT_STEPS,
  DEFAULT_INTEGRATIONS,
} from "@/lib/shared";

const FEATURES = [
  {
    Icon: Smartphone,
    title: "Inventario Centralizado",
    desc: "Visualiza y gestiona todos los dispositivos de tu organización desde un solo lugar.",
  },
  {
    Icon: RefreshCw,
    title: "Actualizaciones Remotas",
    desc: "Aplica firmware y configuraciones sin intervención física en sitio.",
  },
  {
    Icon: AlertCircle,
    title: "Monitoreo Proactivo",
    desc: "Detecta fallas de dispositivos antes de que afecten a los usuarios.",
  },
];

const DeviceManagerPage = () => {
  useDocumentTitle("Caruna Device Manager — Gestión de Dispositivos");
  return (
    <ProductPage
      category="device-manager"
      eyebrow="GESTIÓN DE DISPOSITIVOS"
      headline="Caruna Device Manager"
      subhead="Administra todos tus teléfonos y salas MTR desde un panel centralizado."
      features={FEATURES}
      steps={DEFAULT_STEPS}
      integrations={DEFAULT_INTEGRATIONS}
      ctaHeadline="Solicita una evaluación técnica de Caruna Device Manager"
      baseTech="IP Phone Manager / OVOC"
      heroBody="Caruna Device Manager administra desde un panel único todos tus teléfonos y salas MTR: inventario centralizado, actualizaciones remotas de firmware y monitoreo proactivo que detecta fallas antes de que afecten a los usuarios."
    />
  );
};

export default DeviceManagerPage;
